// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WrsHOgYSPVRgkSiF6HWx{min-height:100px;display:flex;width:100%}.WrsHOgYSPVRgkSiF6HWx .z5PKDU3paLhL4_3bASVq{display:flex}.WrsHOgYSPVRgkSiF6HWx .z5PKDU3paLhL4_3bASVq .WAXZi9rf1vSCVSKDfRzB{display:flex;gap:1em;border-bottom:4px solid #141941}.WrsHOgYSPVRgkSiF6HWx .z5PKDU3paLhL4_3bASVq .WAXZi9rf1vSCVSKDfRzB .SzjglaG1VWT_Rh0xrEzA{display:flex;gap:1em;width:200px}.WrsHOgYSPVRgkSiF6HWx .z5PKDU3paLhL4_3bASVq .WAXZi9rf1vSCVSKDfRzB .SzjglaG1VWT_Rh0xrEzA .MfIeWptN4EELSD8frrQ9{display:flex;height:100%;width:13px;flex-direction:column;align-items:center}.WrsHOgYSPVRgkSiF6HWx .z5PKDU3paLhL4_3bASVq .WAXZi9rf1vSCVSKDfRzB .SzjglaG1VWT_Rh0xrEzA .MfIeWptN4EELSD8frrQ9 .HnYZIfLexhn7eqCtEqYD{border-radius:7px;height:13px;width:13px;background-color:#1ec8fa}.WrsHOgYSPVRgkSiF6HWx .z5PKDU3paLhL4_3bASVq .WAXZi9rf1vSCVSKDfRzB .SzjglaG1VWT_Rh0xrEzA .MfIeWptN4EELSD8frrQ9 .aozcxl2rYyiNQ9KL1KIG{background-color:#1ec8fa;width:1px;flex:1}.WrsHOgYSPVRgkSiF6HWx .z5PKDU3paLhL4_3bASVq .WAXZi9rf1vSCVSKDfRzB .SzjglaG1VWT_Rh0xrEzA .MfIeWptN4EELSD8frrQ9 .khNPuxPwkfIqxiB6e47M{background-color:#141941;border-radius:3px 3px 0 0;height:3px;width:5px}.WrsHOgYSPVRgkSiF6HWx .z5PKDU3paLhL4_3bASVq .WAXZi9rf1vSCVSKDfRzB .SzjglaG1VWT_Rh0xrEzA .zfCqWoZWLKJc1nvyW4dN{display:flex;flex-direction:column;align-items:flex-start}.WrsHOgYSPVRgkSiF6HWx .z5PKDU3paLhL4_3bASVq .WAXZi9rf1vSCVSKDfRzB .SzjglaG1VWT_Rh0xrEzA .zfCqWoZWLKJc1nvyW4dN .qbQBSrSLsdPz7l26wS38 h2{margin-top:0}.WrsHOgYSPVRgkSiF6HWx .z5PKDU3paLhL4_3bASVq .WAXZi9rf1vSCVSKDfRzB .SzjglaG1VWT_Rh0xrEzA .zfCqWoZWLKJc1nvyW4dN .sQjNc2Xhn4dLr0vEOgyi{flex:1;padding-bottom:.5em}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"primary-dark": `#e73b05`,
	"primary": `#ff6040`,
	"primary-light": `#ffe4df`,
	"primary-extra-light": `#fff2f0`,
	"secondary-dark": `#8292b1`,
	"secondary": `#99a8c6`,
	"secondary-light": `#d0dae9`,
	"secondary-extra-light": `#eef4fc`,
	"default-dark": `#898ca7`,
	"default": `#b8baca`,
	"default-light": `#ecedf5`,
	"default-extra-light": `#f8f8f8`,
	"warning-dark": `#d96800`,
	"warning": `#fbab00`,
	"warning-light": `#ffeba3`,
	"warning-extra-light": `#fff5d1`,
	"info-dark": `#0a82c6`,
	"info": `#2eb6ea`,
	"info-light": `#beebfc`,
	"info-extra-light": `#dff5fe`,
	"success-dark": `#069941`,
	"success": `#3aaa35`,
	"success-light": `#c6f1c3`,
	"success-extra-light": `#e3f9e1`,
	"danger-dark": `#cd0101`,
	"danger": `#ff4141`,
	"danger-light": `#ffcece`,
	"danger-extra-light": `#ffe7e7`,
	"text-primary": `#131a4f`,
	"text-secondary": `#8292b1`,
	"shadow-25": `rgba(184,186,202,.25)`,
	"shadow-50": `rgba(184,186,202,.5)`,
	"root": `WrsHOgYSPVRgkSiF6HWx`,
	"scrollContainer": `z5PKDU3paLhL4_3bASVq`,
	"entriesContainer": `WAXZi9rf1vSCVSKDfRzB`,
	"entryContainer": `SzjglaG1VWT_Rh0xrEzA`,
	"lineContainer": `MfIeWptN4EELSD8frrQ9`,
	"bigDot": `HnYZIfLexhn7eqCtEqYD`,
	"line": `aozcxl2rYyiNQ9KL1KIG`,
	"smallDot": `khNPuxPwkfIqxiB6e47M`,
	"contentContainer": `zfCqWoZWLKJc1nvyW4dN`,
	"header": `qbQBSrSLsdPz7l26wS38`,
	"text": `sQjNc2Xhn4dLr0vEOgyi`
};
export default ___CSS_LOADER_EXPORT___;
